import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const connStr = window.__config__?.APPINSIGHTS_CONNECTION_STRING;

let appInsights = null;

if (connStr) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: connStr,
      enableAutoRouteTracking: true,   // track SPA page views on route change
      disableFetchTracking: false,     // track fetch/XHR calls
      enableCorsCorrelation: true,     // correlate FE requests to BE traces
    }
  });
  appInsights.loadAppInsights();
}

export { appInsights };
